import { KoobTooltip } from '@koob/ui';
import { useTranslation } from 'react-i18next';

export default function VersionExportButton({ tripId, versionId }) {
  const { t } = useTranslation('tripDesigner');

  const openExport = () => {
    window.open(`/trips/${tripId}/export?version=${versionId}`, '_blank');
  };

  return (
    <button
      aria-label={t('compose.versions.exportButtonTooltip')}
      onClick={() => openExport()}
      className="group bg-orange-100 hover:bg-orange-500 border-none transition z-20"
    >
      <KoobTooltip
        tip={t('compose.versions.exportButtonTooltip')}
        position="left"
      >
        <div className="h-10 w-10 flex justify-center items-center">
          <i className="far fa-book text-lg text-gray-600 group-hover:text-white transition" />
        </div>
      </KoobTooltip>
    </button>
  );
}
